import type { Price } from "../prices/price";
import { sumPrices } from "../prices/sum-prices";
import type { PayRequestItem } from "./pay-request-item";

const payRequestPriceCalculator = (
    payRequestItems: PayRequestItem[],
): Price => {
    return sumPrices(payRequestItems.map(item => item.price));
};
export { payRequestPriceCalculator };
